module.exports = __webpack_public_path__ + "img/71.ab0e05e4.png";